import {
  Box,
  Stack,
  Typography,
  styled,
  StackProps,
  ButtonProps,
} from "@mui/material";
import { FONT_COLORS } from "../../../../constants";
import { ReactNode } from "react";

type TSettingsWrapperProps = StackProps & {
  heading?: string;
  subHeading?: string;
  renderButton?: (props: ButtonProps) => ReactNode;
};

const StyledStack = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  gap: theme.spacing(10),
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    gap: theme.spacing(1),
  },
}));

const DEFAULT_BUTTON_PROPS: ButtonProps = {
  variant: "text",
  sx: {
    px: 0,
  },
};

export const SettingsWrapper = ({
  children,
  heading,
  subHeading,
  renderButton,
  ...restProps
}: TSettingsWrapperProps) => {
  return (
    <StyledStack {...restProps}>
      <Box flex={1} minWidth={230} gap={1}>
        {heading && (
          <Typography
            fontSize={14}
            fontWeight={600}
            color={FONT_COLORS.default}
          >
            {heading}
          </Typography>
        )}
        {subHeading && (
          <Typography
            fontSize={12}
            fontWeight={500}
            color={FONT_COLORS.subheading}
          >
            {subHeading}
          </Typography>
        )}
        {renderButton && renderButton(DEFAULT_BUTTON_PROPS)}
      </Box>
      <Stack flex={1} flexDirection="column" overflow="auto">
        {children}
      </Stack>
    </StyledStack>
  );
};
